import { axiosInstance } from "@src/api/axiosConfig";
import { axiosPath } from "@src/api/axiosPath";
import { CorpSearchListDto } from "../dto/SearchList.dto";

export const usePrevCorpDeungi = async (info: CorpSearchListDto) => {
    const response = await axiosInstance.get(
        `${axiosPath.prevCorpDeungi}?registCode=${info.registCode}&corporationName=${info.corporationName}&jurisdictOfficeCode=${info.jurisdictOfficeCode}&corporationTypeCode=${info.corporationTypeCode}`,
    );
    return response;
};
